import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { IHttpService, isArray } from 'angular';

export abstract class RequestBuilder<T> {
  protected config: any = {};
  protected data: any = null;
  protected oldBaseUrl: string;

  /**
   * Creates an instance of RequestBuilder.
   * @param {IHttpService} http angular service
   * @param {any} sessionDeprecatedService session service
   * @param {string} baseUrl REST base URL
   */
  constructor(
    protected readonly $http: IHttpService,
    protected readonly sessionDeprecatedService: SessionDeprecatedService,
    protected readonly baseUrl: string
  ) {
    this.oldBaseUrl = this.baseUrl + '/facade';
  }

  /**
   * Set request configuration
   * @param {Object} options the request configuration object (see angular
   * @returns {RequestBuilder}
   */
  withConfig(options: Object): this {
    this.config = options;
    return this;
  }

  /**
   * Set request data
   * @param {string|Object} body the data object to send
   * @returns {RequestBuilder}
   */
  withData(body: string | Object): this {
    this.data = body;
    return this;
  }

  /**
   * Execute HTTP GET request
   * @param {string} path the path of the request relative to REST base URL.
   * @param {((string|number|boolean)[])} [pathParams] the path parameters as array.
   * @returns {T}
   */
  abstract get(path: string, pathParams?: (string | number | boolean)[]): T;
  /**
   * Execute HTTP HEAD request
   * @param {string} path the path of the request relative to REST base URL.
   * @param {((string|number|boolean)[])} [pathParams] the path parameters as array.
   * @returns {T}
   */
  abstract head(path: string, pathParams?: (string | number | boolean)[]): T;
  /**
   * Execute HTTP POST request
   * @param {string} path the path of the request relative to REST base URL.
   * @param {((string|number|boolean)[])} [pathParams] the path parameters as array.
   * @returns {T}
   */
  abstract post(path: string, pathParams?: (string | number | boolean)[]): T;
  /**
   * Execute HTTP PUT request
   * @param {string} path the path of the request relative to REST base URL.
   * @param {((string|number|boolean)[])} [pathParams] the path parameters as array.
   * @returns {T}
   */
  abstract put(path: string, pathParams?: (string | number | boolean)[]): T;
  /**
   * Execute HTTP DELETE request
   * @param {string} path the path of the request relative to REST base URL.
   * @param {((string|number|boolean)[])} [pathParams] the path parameters as array.
   * @returns {T}
   */
  abstract delete(path: string, pathParams?: (string | number | boolean)[]): T;
  /**
   * Execute HTTP JSONP request
   * @param {string} path the path of the request relative to REST base URL.
   * @param {((string|number|boolean)[])} [pathParams] the path parameters as array.
   * @returns {T}
   */
  abstract jsonp(path: string, pathParams?: (string | number | boolean)[]): T;
  /**
   * Execute HTTP PATCH request
   * @param {string} path the path of the request relative to REST base URL.
   * @param {((string|number|boolean)[])} [pathParams] the path parameters as array.
   * @returns {T}
   */
  abstract patch(path: string, pathParams?: (string | number | boolean)[]): T;

  protected buildUrl(path: string, pathParams?: (string | number | boolean)[]): string {
    let pathParamsStr = '';
    let needSession = path.indexOf('V2') !== 0 && path.indexOf('facade/public') !== 0;
    if (isArray(pathParams)) {
      pathParams.forEach(param => {
        pathParamsStr = pathParamsStr + '/' + param;
      });
    }
    if (needSession) {
      return this.oldBaseUrl + '/' + path + '/' + this.sessionDeprecatedService.get() + pathParamsStr;
    } else {
      return this.baseUrl + '/' + path + pathParamsStr;
    }
  }
}
